const initialGeoVisibilityState = {
  gridResults: null,
  gridLoading: false,
  gridError: null,
  gridProgress: { completed: 0, total: 0, running: false },
  cellRankings: null,
  cellRankingsLoading: false,
  queries: null,
  queriesLoading: false,
  mentions: null,
  mentionsLoading: false,
  metrics: null,
  metricsLoading: false,
};

const geoVisibilityActions = {
  GEO_SET_GRID: 'GEO_SET_GRID',
  GEO_SET_GRID_LOADING: 'GEO_SET_GRID_LOADING',
  GEO_SET_GRID_ERROR: 'GEO_SET_GRID_ERROR',
  GEO_SET_PROGRESS: 'GEO_SET_PROGRESS',
  GEO_SET_CELL_RANKINGS: 'GEO_SET_CELL_RANKINGS',
  GEO_SET_CELL_RANKINGS_LOADING: 'GEO_SET_CELL_RANKINGS_LOADING',
  GEO_SET_QUERIES: 'GEO_SET_QUERIES',
  GEO_SET_QUERIES_LOADING: 'GEO_SET_QUERIES_LOADING',
  GEO_SET_MENTIONS: 'GEO_SET_MENTIONS',
  GEO_SET_MENTIONS_LOADING: 'GEO_SET_MENTIONS_LOADING',
  GEO_SET_METRICS: 'GEO_SET_METRICS',
  GEO_SET_METRICS_LOADING: 'GEO_SET_METRICS_LOADING',
  GEO_CLEAN: 'GEO_CLEAN',
};

const geoVisibilityReducer = (state, action) => {
  switch (action.type) {
    case geoVisibilityActions.GEO_SET_GRID:
      return { ...state, gridResults: action.payload, gridLoading: false, gridError: null };
    case geoVisibilityActions.GEO_SET_GRID_LOADING:
      return { ...state, gridLoading: true, gridError: null };
    case geoVisibilityActions.GEO_SET_GRID_ERROR:
      return { ...state, gridLoading: false, gridError: action.payload };
    case geoVisibilityActions.GEO_SET_PROGRESS:
      return { ...state, gridProgress: action.payload };
    case geoVisibilityActions.GEO_SET_CELL_RANKINGS:
      return { ...state, cellRankings: action.payload, cellRankingsLoading: false };
    case geoVisibilityActions.GEO_SET_CELL_RANKINGS_LOADING:
      return { ...state, cellRankingsLoading: true };
    case geoVisibilityActions.GEO_SET_QUERIES:
      return { ...state, queries: action.payload, queriesLoading: false };
    case geoVisibilityActions.GEO_SET_QUERIES_LOADING:
      return { ...state, queriesLoading: true };
    case geoVisibilityActions.GEO_SET_MENTIONS:
      return { ...state, mentions: action.payload, mentionsLoading: false };
    case geoVisibilityActions.GEO_SET_MENTIONS_LOADING:
      return { ...state, mentionsLoading: true };
    case geoVisibilityActions.GEO_SET_METRICS:
      return { ...state, metrics: action.payload, metricsLoading: false };
    case geoVisibilityActions.GEO_SET_METRICS_LOADING:
      return { ...state, metricsLoading: true };
    case geoVisibilityActions.GEO_CLEAN:
      return { ...initialGeoVisibilityState };
    default:
      return state;
  }
};

export { geoVisibilityReducer, initialGeoVisibilityState, geoVisibilityActions };
